import * as React from 'react';
import { DevPlanFieldAndAnswer } from '../models';
import LocalDiv from '../../../localization/LocalDiv';
import { isNilOrEmpty } from '../../../language/module';
import { useProjIds } from '../../../navigation/hooks';
import { useAppState } from '../../../core/redux/hooks';
import { useUpdateFieldAnswerListModalProps } from './hooks';
import { css } from '@emotion/core';
import { COLORS } from '../../../globalStyle/colors';
import DevActionListModal from './DevActionListModal';
import LocalHTMLContainer from '../../../localization/LocalHTMLContainer';


const styles = {
  label:           css`
    color: ${COLORS.DARK_GREY};
    font-size: 12px;
    line-height: 15px;
    font-weight: bold;
  `,
  placeholder: [
    css`
      font-size: 13px;
      font-style: italic;
      color: ${COLORS.FIELD_GREY};
    `,
  ],
};

type Props = {
  field: DevPlanFieldAndAnswer;
  devItemCompetencyId?: number;
  disableModal: boolean;
  placeholder: string;
  className?: string;
}

/**
 * DevPlanListField: a component that renders the user's answer(s) to the provided dev action list field
 *
 *  * Note that this component is not used for fields that take an open-ended answer - only list fields. See
 * `DevActionField` for handling open-ended answer fields.
 */
const DevActionListField: React.FC<Props> = ({ field, devItemCompetencyId, disableModal, placeholder, className }) => {
  const { projId, participantId } = useProjIds();

  const langId = useAppState(state => state.locale.lang.languageId);

  const { devItemId, devActionId, devPlanFieldId, devPlanFieldAnswerId } = field;

  const devPlanProjectId = useAppState(state => state.projectSummary?.devPlanProjectId || projId);

  const {
          modalVisible, toggleModal, isSelected, onClickListItemCheckbox, onClickConfirmAdd,
        } = useUpdateFieldAnswerListModalProps(
    devPlanProjectId,
    participantId,
    langId,
    devItemId,
    devActionId,
    devPlanFieldId,
    devPlanFieldAnswerId,
    disableModal,
  );

  return (
    <label
      key={field.question}
      onClick={toggleModal}
      className={className}
    >
      <span css={styles.label}>{field.question}</span>
      <LocalDiv onClick={toggleModal}>
        {
          isNilOrEmpty(field.answers)
            ? <span css={styles.placeholder}>{placeholder}</span>
            : field.answers.map(answer => <LocalHTMLContainer innerHtml={answer} />)
        }
        {
          modalVisible && (
            <DevActionListModal
              devItemCompetencyId={devItemCompetencyId}
              dismiss={toggleModal}
              isSelected={isSelected}
              onClickListItemCheckbox={onClickListItemCheckbox}
              onClickConfirmAdd={onClickConfirmAdd}
            />
          )
        }
      </LocalDiv>
    </label>
  );
};

export default DevActionListField;
